var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSleepActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_1107_3",
    "data-name": "Componente 1107 \\u2013 3",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.931,
    height: 15.428,
    viewBox: "0 0 14.931 15.428",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3707",
    "data-name": "Caminho 3707",
    d: "M24.461,1A1,1,0,1,0,22.47,1V7.963a1,1,0,1,0,1.991,0ZM19.966,3.751a1,1,0,1,0-1.275-1.53,7.467,7.467,0,1,0,9.546,0,1,1,0,1,0-1.275,1.53,5.475,5.475,0,1,1-7,0Z",
    transform: "translate(-16 0)",
    fill: "#17CB55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleepActive);
export default __webpack_public_path__ + "static/media/sleep-active.19f6a2b1a4b8cabf288c1a69853b3c5f.svg";
export { ForwardRef as ReactComponent };